import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import CreateVehicleFormik from '../../../containers/vehicles/CreateVehicleFormik'
import EditProductsPane from '../../../containers/vehicles/EditProductsPane'
import Accommodations from '../../../containers/vehicles/Accomodations'
import AccessAndCapacity from '../../../containers/vehicles/AccessAndCapacity'

const EditVehiclePane = (props: RouteComponentProps<{ id: string }>) => {
  return (
    <div>
      <div className='w100'>
        <div className='p2 pt1 col-12 border-top nav-shadow'>
          <span className='h3 font-grey2'>Create New Vehicle</span>
        </div>
      </div>
      <Switch>
        <Route path={`${props.match.path}personal-info`} component={CreateVehicleFormik} />
        <Route
          path={`${props.match.path}products/:id`}
          component={EditProductsPane('/vehicles/create/access-capacity')}
        />
        <Route
          path={`${props.match.path}access-capacity/:id`}
          component={AccessAndCapacity('/vehicles/create/accommodations')}
        />
        <Route path={`${props.match.path}accommodations/:id`} component={Accommodations} />
      </Switch>
    </div>
  )
}

export default EditVehiclePane



// WEBPACK FOOTER //
// ./src/components/vehicles/create-vehicle/CreateVehiclePane.tsx